<template>
  <div class="mastery-heading-container">
    <img
      :src="$store.getters['app/appLogo']"
      alt=""
      role="presentation"
    >
    <div>{{ name }} {{ $store.getters['app/appName'] }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      if (this.$store.getters['session/currentUser']) {
        return `${this.$store.getters['session/currentUser'].firstName}'s`;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
  .mastery-heading-container {
    align-items: center;
    display: flex;
    font-size: rem-calc(22);
    justify-content: center;
    margin-bottom: rem-calc(32);
    text-align: center;

    img {
      margin-right: rem-calc(12);
      width: rem-calc(32);
    }

    div {
      font-weight: $semi-bold;
    }
  }
</style>
